import React, { PropTypes as T } from 'react';
import Cookies from 'js-cookie';
import FullScreenBtn from './fullscreenbtn';
import Button from '../common/button';
import SeatMapIcon from '../common/icons/icon_seat_map';
import SearchIcon2 from '../common/icons/icon_search2';
import withDevice from '../common/withDeviceHOC';
import translate from '../../utils/translate';
import fullScreenActions from '../../actions/fullscreen';
import BasketActions from '../../actions/basket';
import Map from './map';
import Errors from './errors';

class MapContainer extends React.Component {
  static propTypes = {
    fullscreen: T.object,
    basket:     T.object,
    eventinfo:  T.object,
    isMobile: T.bool
  };

  componentDidMount () {
    if (this.props.isMobile && Cookies.get('autoExpandISM')) {
      this.toggleFullScreenIsm();
      Cookies.remove('autoExpandISM');
    }
  }

  toggleFullScreenIsm = () => {
    fullScreenActions.toggle('ism');
  };

  goToBestAvailable = () => {
    BasketActions.goToBestAvailable(this.props.basket.config.eventId);
  };

  render () {
    const isFullScreen = this.props.fullscreen.activeModule === 'ism';
    const hasLoadError = this.props.basket.error.errorCode === 'LOAD_ERROR';

    return (
      <div className="ism">
        { !hasLoadError && <FullScreenBtn isFullScreen={isFullScreen} /> }
        { !hasLoadError && this.props.isMobile &&
          <Button primary flex icontext
            className="cButton--buyonmap"
            onClick={this.toggleFullScreenIsm}
            data-component="full-screen-btn">
            <SeatMapIcon />
            <span>{translate('pageTranslations', 'BUY_ON_MAP')}</span>
          </Button> }
        { !hasLoadError && this.props.isMobile &&
          <Button primary flex outlined icontext onClick={this.goToBestAvailable}>
            <SearchIcon2 />
            <span>{translate('pageTranslations', 'FIND_SEATS_FOR_ME')}</span>
          </Button>}
        { !hasLoadError && <Map {...this.props} /> }
        <Errors {...this.props.basket} eventId={this.props.eventinfo.eventId} />
      </div>
    );
  }
}

export default withDevice(MapContainer);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/index.js